import { render } from "./HomeTab.vue?vue&type=template&id=0bc73d36&scoped=true"
import script from "./HomeTab.vue?vue&type=script&lang=js"
export * from "./HomeTab.vue?vue&type=script&lang=js"

import "./HomeTab.vue?vue&type=style&index=0&id=0bc73d36&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc73d36"]])

export default __exports__